import jQuery from 'jquery';
import _ from 'lodash';
import ubBanzai from 'ub/control/banzai-features';
import endpoints from 'ub/config/endpoints';
import ajaxAsObservable from 'ub/control/ajax-as-observable';

const TIME_OUT = 1000;
const TAKE = 1;
const RETRIES = 3;

const addContext = (data) => {
  const page = window.editor.mainPage;
  const userId = window.gon && window.gon.user ? window.gon.user.id : null;
  const clientId = window.gon ? window.gon.client_id : null;
  const accountId = window.gon ? window.gon.current_account_id : null;

  const context = {
    ts: new Date().toISOString(),
    msgSchemaVersion: '0.1',
    sessionId: window.lp.getSessionId(),
    sessionIncrement: window.lp.sessionIncrement,
    pageUuid: page.uuid,
    variantId: page.id, // db id vs "variant a, b"
    userId,
    clientId,
    accountId,
    builderVersion: window.builderVersion
  };

  return _.merge(data, context);
};

const fetchUserToken = () => {
  const csrfIndex = 0;
  const csrfMetaTag = jQuery('meta[name=csrf-token]')[csrfIndex];
  const authToken = csrfMetaTag ? csrfMetaTag.readAttribute('content') : '';

  return ajaxAsObservable({
    type: 'POST',
    url: endpoints.userAccessToken(window.gon.client_id),
    headers: {'X-CSRF-Token': authToken}
  })
  .pluck('data', 'token');
};

const trackEvent = (payload, subjectName) => {
  if (ubBanzai.features.isSandboxEnabled()) {
    return;
  }

  const payloadWithContext = addContext(payload);
  const gatewayHost = ubBanzai.getFeatureValue('eventsGatewayHostname');

  fetchUserToken()
  .flatMap(({token}) => {
    return ajaxAsObservable({
      type: "POST",
      url: `https://${gatewayHost}/events/page_builder_user?subject=${subjectName}`,
      xhrFields: {withCredentials: true},
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: JSON.stringify(payloadWithContext),
      headers: {Authorization: `Bearer ${token}`}
    })
    .timeout(TIME_OUT)
    .retry(RETRIES)
    .take(TAKE);
  })
  .catch((error) => {
    console.trace(error);
  })
  .subscribe(() => {
    console.log(`${subjectName} saveTrace:`, payloadWithContext, gatewayHost);
  });
};

export default {
  addContext,
  fetchUserToken,
  trackEvent
};



// WEBPACK FOOTER //
// ./src/user-event-tracking.js